var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFocusareaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    id: "focusareaicon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline_Icons"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.5,5C23.776,5,24,4.776,24,4.5v-4C24,0.224,23.776,0,23.5,0h-4C19.224,0,19,0.224,19,0.5V2H5V0.5C5,0.224,4.776,0,4.5,0 h-4C0.224,0,0,0.224,0,0.5v4C0,4.776,0.224,5,0.5,5H2v14H0.5C0.224,19,0,19.224,0,19.5v4C0,23.776,0.224,24,0.5,24h4 C4.776,24,5,23.776,5,23.5V22h14v1.5c0,0.276,0.224,0.5,0.5,0.5h4c0.276,0,0.5-0.224,0.5-0.5v-4c0-0.276-0.224-0.5-0.5-0.5H22V5 H23.5z M20,1h3v3h-3V1z M1,1h3v3H1V1z M4,23H1v-3h3V23z M23,23h-3v-3h3V23z M21,19h-1.5c-0.276,0-0.5,0.224-0.5,0.5V21H5v-1.5 C5,19.224,4.776,19,4.5,19H3V5h1.5C4.776,5,5,4.776,5,4.5V3h14v1.5C19,4.776,19.224,5,19.5,5H21V19z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Invisible_Shape"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    fill: "none",
    width: 24,
    height: 24
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocusareaIcon);
export default __webpack_public_path__ + "static/media/focusarea-icon.225e0c56d246b5e93a240fb0ba428d4a.svg";
export { ForwardRef as ReactComponent };